export default "__VITE_ASSET__z$dBiW2bcm1feBN$IpljfQ__"